import { ApiKeyCard, McpCard } from "./Settings.js";

/** API Key 와 MCP — 키는 발급 시 한 번만 보이고 해시만 남는다. MCP 는 그 키로 읽기만 한다 */
export function ApiKeys() {
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">⚿</span>
        <div>
          <h1>API Key · MCP</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            수집기(ingest)와 에이전트(read)가 쓰는 키입니다. 키는 발급한 사람의 스코프를 물려받습니다.
          </p>
        </div>
      </div>
      <ApiKeyCard />
      <McpCard />
    </>
  );
}
